import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

import theme from '../../theme';

const ERROR_SUBMIT = ["刪除", "清除", "清空"];

const ModalFooter = ({
  isLoading,
  inputErrorMsg,
  modalContent,
  modalData,
  setModalData,
  handleModalSubmit,
  handleClose,
}) => {

  return (
    <>
      <Stack
        variant='center-center'
        sx={{
          paddingTop: '16px',
          paddingBottom: '32px'
        }}
      >
        <Stack>
          {
            modalContent.cancelTxt &&
            <Button
              variant="text-cancel"
              disabled={isLoading}
              onClick={handleClose}
            >
              {modalContent.cancelTxt}
            </Button>
          }
          {
            modalContent.submitTxt &&
            <Button
              variant="contained"
              color={ERROR_SUBMIT.includes(modalContent.submitTxt) ? "error" : "primary"}
              disabled={isLoading}
              endIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
              onClick={() => handleModalSubmit(modalData, modalContent.name)}
              sx={{ color: "#fff" }}
            >
              {modalContent.submitTxt}
            </Button>
          }
        </Stack>
      </Stack>
    </>
  )
}

export default ModalFooter;